import React, { useRef, useState } from "react";
import {
  Overlay,
  Modal,
  CloseButton,
  Title,
  Buttons,
  ModalButton,
} from "./styles";

import iconUpload from "../../assets/icons/upload-feedback.svg";
import iconPlus from "../../assets/icons/plus.svg";

interface FileModalProps {
  onClose: () => void;
}

export function FileModal({ onClose }: FileModalProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [dragActive, setDragActive] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  function handleOverlayClick(e: React.MouseEvent<HTMLDivElement>) {
    if (e.target === e.currentTarget) onClose();
  }

  function handleChooseFile() {
    fileInputRef.current?.click();
  }

  function handleDragOver(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragActive(true);
  }

  function handleDragLeave(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragActive(false);
  }

  function processFile(file: File) {
    setSelectedFile(file);

    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
  }

  function handleDrop(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault();
    setDragActive(false);

    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      processFile(files[0]);
    }
  }

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const files = e.target.files;
    if (files && files.length > 0) {
      processFile(files[0]);
    }
  }

  return (
    <Overlay onClick={handleOverlayClick}>
      <Modal>
        <CloseButton onClick={onClose}>×</CloseButton>
        <Title>Fazer Upload do Arquivo</Title>

        <div
          className="square"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{
            border: dragActive ? "2px dashed var(--blue)" : "none",
            backgroundColor: dragActive ? "#e3f2fd" : "#E1E1E1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
            gap: "1rem",
          }}
        >
          
          {selectedFile ? (
            <>
              <p><b>Arquivo selecionado:</b> {selectedFile.name}</p>
              <p>Tamanho: {(selectedFile.size / 1024 / 1024).toFixed(2)} MB</p>

              
            </>
          ) : (
            <>
              <img src={iconUpload} alt="Upload" />
              <p>Arraste o vídeo aqui</p>
              <button type="button" onClick={handleChooseFile}>
                <img src={iconPlus} alt="Escolher arquivo" />
                Escolher Arquivo
              </button>
            </>
          )}

          <input
            type="file"
            accept="video/*"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>

        <Buttons>
          <ModalButton onClick={onClose}>Cancelar</ModalButton>
          <ModalButton disabled={!selectedFile}>Enviar</ModalButton>
        </Buttons>
      </Modal>
    </Overlay>
  );
}
